<!--2025年新挽留 进入预览提现没有提现的挽留红包 免息 xx 天 xx 红包 -->
<template>
  <div class="retainDialog" :style="`background-image:url(${data.icon});`" >
    <div class="retainDialogContent" >
      <div class="content-detail">
        <div class="content" :style="`color:#FF4633`" v-if="data.bizType=== 'OLD_PREVIEW_A'">
          <span class="num">{{data.discountValueV2}}</span>
          <span v-if="data.discountType==='FREE_DAY'" class="ext">天</span><span  class="ext" v-else >元</span>
        </div>
        <div class="endtime">
          <van-count-down :time="countDownSeconds" @finish="countDownEnd" v-if="!expire">
            <template #default="timeData">
              即将失效{{ timeFormat(timeData.minutes) }}分{{ timeFormat(timeData.seconds) }}秒
            </template>
          </van-count-down>
          <span class="expire" v-else>已失效</span>
        </div>
      </div>
      <div class="btn retainDialog" :class="`caseId-${data.caseId}`" data-sensors-click @click="handleButtonClick('TMD_WITHDRAW',data.couponV3Type)"></div>
    </div>
  </div> 
</template>

<script>
import { CountDown } from 'vant'
export default {
  data () {
    return {
      visible: true,
      expire: false    
    }
  },
  components: {
    'van-count-down': CountDown
  },
  props: {
    caseid: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    couponEndTime () {
      return this.data.couponEndTime
    },
    
    countDownSeconds () {
      return Math.floor((this.couponEndTime - Date.now()))
    }
  },
  methods: {
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    countDownEnd () {
      this.expire = true
      // this.close()
    },
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    
    handleButtonClick (skipType) {
      const { couponSerialNo } = this.data
      const query = {
        skipType,
        cacheCouponSerialNo: 'Y'
      }
      if (couponSerialNo) {
        query.couponSerialNo = couponSerialNo
      }
      this.$router.push({
        path: '/middle/coupon',
        query
      })
    },
    show () {}
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

  .retainDialog {
    width: 620px;
    height: 750px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    .retainDialogContent {
      .btn {  
        position: absolute;
        width: 440px;
        height: 80px;
        top:540px;
        left: 90px;
      }
      .content-detail {
        position: absolute;
        top:290px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .content {
          .num {
            font-size: 120px;
            line-height: 120px;
            font-family: DIN-Medium;
            font-weight: 500;
          }
          .ext {
            font-family:  PingFangSC-Medium, PingFang SC;
            font-size:48px;
            font-weight: 500px;
            vertical-align: 10px;
          }
        }
        .endtime  {
          width: 440px;
          height: 54px;
          background: #FFF4F3;
          border-radius: 27px;
          display: flex;justify-content: center;
          align-items: center;
          position: absolute;
          top:140px;
        }
        .expire,.van-count-down{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 34px;
          color: #FF4633;
          line-height: 33px;
        }
      }
    }
     
  }
</style>